/**
 * R158j · Feb 2026 — Shared priority icon.
 * Rendered to the left of task titles across the app.
 *
 * Urgent   → double up-chevrons (red)
 * High     → single up-chevron (amber)
 * Medium   → equals sign        (neutral)
 * Low      → down-chevron       (muted)
 */
import { ChevronsUp, ChevronUp, Minus, ChevronDown } from "lucide-react";

const MAP = {
  urgent: { Icon: ChevronsUp, cls: "text-rose-600", label: "Urgent" },
  high: { Icon: ChevronUp, cls: "text-amber-600", label: "High" },
  medium: { Icon: Minus, cls: "text-neutral-500", label: "Medium" },
  low: { Icon: ChevronDown, cls: "text-neutral-400", label: "Low" },
};

export default function PriorityIcon({ priority = "medium", className = "w-3.5 h-3.5", withLabel = false }) {
  const m = MAP[priority] || MAP.medium;
  const Icon = m.Icon;
  // R158v · Feb 2026 — Boost stroke width for better visibility on
  // small chips and dark presentation backgrounds.
  const iconCls = `shrink-0 ${m.cls} ${className}`;
  if (withLabel) {
    return (
      <span className={`inline-flex items-center gap-0.5 ${m.cls}`} title={`Priority: ${m.label}`}>
        <Icon className={iconCls} strokeWidth={3} />
        <span className="text-[9px] uppercase tracking-widest">{m.label}</span>
      </span>
    );
  }
  return <Icon className={iconCls} strokeWidth={3} data-testid={`priority-icon-${priority}`} aria-label={`Priority ${m.label}`} />;
}

export const PRIORITY_META = MAP;
